module.exports = __webpack_public_path__ + "static/img/Sarah-designer.8bcd154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/Sarah-designer.png
// module id = 2CHW
// module chunks = 1